module.exports = "<button (click)=\"performAction()\" [disabled]=\"OlapService.isLoading\" class=\"btn btn-primary\">\n    {{ OlapService.isLoading ? 'Processing...' : label }}\n</button>"


//////////////////
// WEBPACK FOOTER
// /opt/sss_web/sss_web/src/app/components/app-loading-button/app-loading-button.component.html
// module id = ../../../../../src/app/components/app-loading-button/app-loading-button.component.html
// module chunks = main